var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my_page"})
}
var staticRenderFns = []

export { render, staticRenderFns }